export const MODAL_TYPES = {
  MANADR_CERT: 'manaDRCert',
  DIGI_MC: 'digi-mc',
  PREVIEW_DIGI_MC: 'preview-digi-mc',
  CREATE_MC: 'createMC',
  CONFIRM_GO_TO_ON_GOING_CONSULT: 'confirmGoToOnGoingConsult',
  PREVIEW_IMG: 'previewImage',
};
